import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { CandidacyPlacement, PlacementQueryParams } from "@/types";

export const useRemovePlacement = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({
    id,
    placementQueryParams,
  }: {
    id: number;
    placementQueryParams: PlacementQueryParams;
  }) => {
    queryClient.setQueryData(
      ["placements", currentCompanyId, currentJobId, placementQueryParams],
      (cachedPlacements: CandidacyPlacement[]) =>
        cachedPlacements.filter((p) => p.id !== id),
    );
  };
};
